import type { SessionDataArgs } from '../graphQL/queries/getSession/types'

type ConfigCustomerCodeSession = Pick<
  SessionDataArgs,
  'customerAlias' | 'configBundle'
>

/**
 * The customer code to send with the config fetch, or `null` to leave it as
 * today. Gated on a non-empty `bundleId`, not on `configBundle` itself, so a
 * `{ bundleId: null }` child cannot read as opted in (defensive: an unset
 * subdocument arrives as `null`). The alias is returned verbatim, with no
 * trim or case change (COM-699).
 */
export const customerCodeForConfig = (
  session: ConfigCustomerCodeSession | null | undefined,
): string | null => {
  const bundleId = session?.configBundle?.bundleId
  const alias = session?.customerAlias

  if (typeof bundleId !== 'string' || bundleId === '') {
    return null
  }

  if (typeof alias !== 'string' || alias === '') {
    return null
  }

  return alias
}

export default customerCodeForConfig
